<template>
  <div class="distribution-bar">
    <div class="bar-container">
      <div
        class="bar investment"
        :style="{
          width: investmentBarWidth,
          backgroundColor: investmentBarColor,
        }"
      ></div>
      <div
        class="bar estimated-returns"
        :style="{
          width: estimatedReturnsBarWidth,
          backgroundColor: estimatedReturnsBarColor,
        }"
      ></div>
    </div>
    <div class="values">
      <span class="value">{{ formattedTotalValue }}</span>
      <span class="value">{{ formattedTotalReturns }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DistributionBar",
  props: {
    formattedTotalValue: {
      type: String,
      required: true,
    },
    formattedTotalReturns: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      investmentBarWidth: "50%",
      estimatedReturnsBarWidth: "50%",
      investmentBarColor: "#205AA6",
    };
  },

  watch: {
    formattedTotalValue() {
      this.calculateBarWidths();
    },
    formattedTotalReturns() {
      this.calculateBarWidths();
    },
  },
  mounted() {
    this.calculateBarWidths();
  },
  methods: {
    calculateBarWidths() {
      const investmentAmount = parseFloat(
        this.formattedTotalValue.replace("₹", "").replace(/,/g, "")
      );
      const returnsAmount = parseFloat(
        this.formattedTotalReturns.replace("₹", "").replace(/,/g, "")
      );
      const totalAmount = investmentAmount + returnsAmount;
      console.log(totalAmount);
      this.investmentBarWidth = (investmentAmount / totalAmount) * 100 + "%";
      this.estimatedReturnsBarWidth = (returnsAmount / totalAmount) * 100 + "%";
    },
  },
};
</script>

<style scoped>
.distribution-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bar-container {
  width: 100%;
  height: 20px;
  background-color: #21d19f;
  margin-bottom: 5px;
  position: relative;
}
.bar {
  height: 100%;
  position: absolute;
  top: 0;
}
.investment {
}
.estimated-returns {
}
.labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.label {
  font-size: 12px;
}

.values {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.value {
  font-size: 12px;
}
</style>
